import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

// Import Bootstrap CSS first
import 'bootstrap/dist/css/bootstrap.min.css'

// Import our global styles (includes Inter font and brand colors)
import './styles/global/index.css'

// Import shared component styles
import './styles/shared/components.css'
import './styles/shared/layouts.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
) 